import { createAction, props } from '@ngrx/store';
import { EcddModel } from '@shared/data-access/models';
import { EEcddType } from '@shared/data-access/enums';

export const setItemDetail = createAction('[ECDD] SET ITEM DETAIL', props<{ item: EcddModel | null }>());

export const loadItemDetail = createAction('[ECDD] LOAD ITEM DETAIL', props<{ id: number }>());
